import { useState } from 'react'
import { Card, CardHeader } from '../components/ui/Card'
import { Button } from '../components/ui/Button'
import { useAuthStore } from '../store/authStore'
import { apiClient } from '../api/client'
import pkg from '../../package.json'

const API_URL = import.meta.env.VITE_API_URL as string
const APP_VERSION: string = pkg.version

type TestStatus = 'idle' | 'loading' | 'ok' | 'error'

export default function Settings() {
  const { usuario } = useAuthStore()
  const [testStatus, setTestStatus] = useState<TestStatus>('idle')
  const [testDetail, setTestDetail] = useState<string>('')

  async function handleTestConnection() {
    setTestStatus('loading')
    setTestDetail('')
    try {
      const res = await apiClient.get<unknown>('/health')
      setTestStatus('ok')
      setTestDetail(typeof res.data === 'object' ? JSON.stringify(res.data) : String(res.data))
    } catch (err: unknown) {
      setTestStatus('error')
      if (err instanceof Error) setTestDetail(err.message)
      else setTestDetail('Error desconocido')
    }
  }

  const ua = navigator.userAgent
  const uaTruncated = ua.length > 80 ? ua.slice(0, 80) + '…' : ua

  return (
    <div className="space-y-5 max-w-2xl">
      <h1 className="text-xl font-bold text-slate-900 dark:text-slate-100">Configuración</h1>

      <Card>
        <CardHeader title="Mi cuenta" />
        <div className="space-y-2 text-sm text-slate-600 dark:text-slate-400">
          <div className="flex justify-between"><span>Nombre</span><span className="font-medium text-slate-800 dark:text-slate-200">{usuario?.nombre}</span></div>
          <div className="flex justify-between"><span>Email</span><span className="font-medium text-slate-800 dark:text-slate-200">{usuario?.email}</span></div>
          <div className="flex justify-between"><span>Rol</span><span className="font-medium text-slate-800 dark:text-slate-200">{usuario?.rol}</span></div>
          <div className="flex justify-between"><span>Tenant ID</span><code className="text-xs bg-slate-100 dark:bg-slate-800 px-1 rounded">{usuario?.tenantId}</code></div>
        </div>
      </Card>

      <Card>
        <CardHeader title="Plan y facturación" subtitle="Pendiente — integración Paddle" />
        <div className="py-8 text-center text-slate-400 text-sm">
          Billing via Paddle — próximamente
        </div>
      </Card>

      <Card>
        <CardHeader title="Usuarios del tenant" subtitle="Pendiente — CRUD usuarios" />
        <div className="py-8 text-center text-slate-400 text-sm">
          Gestión de supervisores y auditores — próximamente
        </div>
      </Card>

      <Card>
        <CardHeader title="Tipos de máquina" subtitle="Benchmarks de consumo L/h por tipo" />
        <div className="py-8 text-center text-slate-400 text-sm">
          Consumirá <code className="bg-slate-100 dark:bg-slate-800 px-1 rounded">GET /tipos-maquina</code> — próximamente
        </div>
      </Card>

      <Card>
        <CardHeader title="API Configuration" />
        <div className="space-y-3 text-sm text-slate-600 dark:text-slate-400">
          <div className="flex justify-between items-center gap-4">
            <span className="shrink-0">API URL</span>
            <code className="text-xs bg-slate-100 dark:bg-slate-800 px-2 py-1 rounded break-all text-right">{API_URL}</code>
          </div>
          <div className="flex justify-between items-center">
            <span>Versión frontend</span>
            <code className="text-xs bg-slate-100 dark:bg-slate-800 px-2 py-1 rounded">{APP_VERSION}</code>
          </div>
          <div className="flex justify-between items-center">
            <span>Timezone</span>
            <code className="text-xs bg-slate-100 dark:bg-slate-800 px-2 py-1 rounded">{Intl.DateTimeFormat().resolvedOptions().timeZone}</code>
          </div>
          <div className="flex flex-col gap-1">
            <span>User Agent</span>
            <code className="text-xs bg-slate-100 dark:bg-slate-800 px-2 py-1 rounded break-all">{uaTruncated}</code>
          </div>
          <div className="flex items-center gap-3 pt-1">
            <Button variant="secondary" size="sm" onClick={handleTestConnection} disabled={testStatus === 'loading'}>
              {testStatus === 'loading' ? 'Probando…' : 'Test connection'}
            </Button>
            {testStatus === 'ok' && (
              <span className="text-xs text-green-600 dark:text-green-400 font-medium">OK — {testDetail}</span>
            )}
            {testStatus === 'error' && (
              <span className="text-xs text-red-600 dark:text-red-400 font-medium">Error — {testDetail}</span>
            )}
          </div>
        </div>
      </Card>
    </div>
  )
}
